import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import PasswordInput from './PasswordInput';

export default function LoginForm({ onSwitch, onForgot }) {
  const { t } = useTranslation('auth');
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Normalize the email client-side to match the forgot-password
      // flow (and the now-normalized server-side authenticate()).  This
      // avoids browser-autofill / iOS auto-capitalize false-negatives
      // where the stored email is "demo1@flowgenix.local" but the user
      // typed (or the browser supplied) "Demo1@flowgenix.local".
      await login(email.trim().toLowerCase(), password);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) {
        setError(t('invalid_credentials'));
      } else if (!err?.response) {
        setError('Cannot reach the server. Please check your connection.');
      } else {
        setError(`Login failed (${status || 'error'}). Please try again.`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="auth-brand">
        <img
          src="/teachiq-logo.png"
          alt="TeachIQ"
          className="auth-brand-logo"
        />
        <div className="auth-brand-text">
          <span className="auth-brand-tagline">Smarter Teaching, Longer Impact</span>
          <span className="auth-brand-sub">A Flowgenix Labs Product</span>
        </div>
      </div>
    <div className="auth-card">
      <h1 className="auth-title">{t('login_title')}</h1>
      <p className="auth-subtitle">{t('login_subtitle')}</p>
      {error && <div className="auth-error">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>{t('email')}</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>{t('password')}</label>
          <PasswordInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>
        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? '...' : t('login')}
        </button>
      </form>
      {typeof onForgot === 'function' && (
        <p className="auth-switch" style={{ marginTop: 8 }}>
          <button type="button" className="link-btn" onClick={onForgot}>
            Forgot password?
          </button>
        </p>
      )}
      <p className="auth-switch">
        {t('no_account')} <button className="link-btn" onClick={onSwitch}>{t('register')}</button>
      </p>
    </div>
    </>
  );
}
